// enums/Status.js
export const IdentityEnum: { [key: number]: string } = {
    0: 'Vazio',
    1: 'Registro Contábil',
    2: 'Pessoa Física',
    3: 'Pessoa Jurídica',
    4: 'Importação'

};
export const PurposeEnum: { [key: number]: string } = {
    0: 'Vazio',
    1: 'Outros',
    2: 'Protótipos',
    3: 'Tecnológicos'
};

export const JustificationEnum: { [key: number]: string } = {
    0: 'Vazio',
    1: 'Outros',
    2: 'Tecnológicos'
};